import { VerticalFlex } from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import Header from './Header'

const useStyles = makeStyles({
  main: {
    height: '100%',
    alignItems: 'center',
    gap: '24px', // equivalent to 'wide' spacing
  },
})

const AppContentLayout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const classes = useStyles()
  return (
    <VerticalFlex is="main" className={classes.main}>
      <Header />
      {children}
    </VerticalFlex>
  )
}

export default AppContentLayout
